import { useTranslation } from "react-i18next";
import { useProjects } from "../../../projects/projectContext";
import WorkflowLibrary from "./WorkflowLibrary";

/** The Workflows section's sidebar: the project's Workflows, the one place to browse them (F36, SB-19). */
export default function WorkflowsSidebar() {
  const { t } = useTranslation();
  const projectId = useProjects().selectedProjectId;
  if (projectId === null) {
    return <p className="app-text-muted px-4 py-3 text-xs">{t("projects.needed.title")}</p>;
  }
  return <WorkflowLibrary projectId={projectId} />;
}
